import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-admin";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";

const ChangeTeamsButton = ({ game, className = "" }) => {
  const gameData = {
    ...game,
    date: game.gameDateString,
    time: game.gameTimeString,
    homeSeasonTeam: game.home.season.id,
    awaySeasonTeam: game.away.season.id,
    isChangingTeams: true
  };

  return (
    <Button
      component={Link}
      to={{
        pathname: "/games/create",
        state: { record: gameData }
      }}
      label="Change Teams"
      color="primary"
      variant="outlined"
      className={className}
    >
      <CompareArrowsIcon />
    </Button>
  );
};

export default ChangeTeamsButton;
